import * as React from "react";
import { Download } from "lucide-react";

import { BulkDeletionState } from "../../models/Jobs/BulkDeletion";

/**
 * The counts a run accumulated, and its report of what it could not delete.
 */
/*
 * Rendered as a span throughout: these sit inside the name cell of the deletion tables, which is itself a
 * span, so a block element here would be invalid nesting.
 */
export const BulkDeletionSummary: React.FC<{ bulk: BulkDeletionState }> = ({ bulk }) => (
  <span className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-muted-foreground">
    <span className="font-medium text-foreground">Uploaded list</span>
    {bulk.recordsOnly && <span className="font-medium text-foreground">Records only</span>}
    <span>{bulk.totalRows} uploaded</span>
    <span>{bulk.deletedCount} deleted</span>
    {bulk.notFoundCount > 0 && <span>{bulk.notFoundCount} not found</span>}
    {bulk.malformedCount > 0 && <span>{bulk.malformedCount} not an id</span>}
    {bulk.failedCount > 0 && <span className="text-destructive">{bulk.failedCount} failed</span>}
    {bulk.failuresCsvUrl && (
      <a
        className="inline-flex items-center gap-1 underline"
        href={bulk.failuresCsvUrl}
        target="_blank"
        rel="noreferrer"
      >
        <Download className="size-3" />
        Report
      </a>
    )}
  </span>
);
